<template>
  <div class="mycommands flex-bet margin010">
    <div class="title flex-center">
      <img v-if="documentImageUrl" :src="documentImageUrl" alt="Documents 55x55" />
      <div>{{ title }}</div>
    </div>
    <div class="flex-center">
      <div class="title">
        <button name="button" type="button" class="js-tooltip btn btn-link" style="padding: 0" data-original-title="" title="">
          <i class="fa-light fa-chevron-left pulsante_comando js-tooltip" title="" data-original-title="Indietro" @click="goBack"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'genericTitleBar',
  props: ['documentImageUrl', 'title'],
  components: {},
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;
}
.flex-bet {
  display: flex;
  justify-content: space-between;
}
</style>
